<template>
  <div class="SearchPage">
    <div class="container">
      <ImageSlider :images="response.sliders" v-if="755 < screen" />
      <ImageSliderMobile :images="response.sliders" v-if="755 >= screen" />
        <div class="search-form my-5" dir="rtl">
            <p><b>{{$route.query.q}}</b></p>
        </div>
      </div>
      <div class="container" v-if="products">
        <div class="row justify-content-center">
          <template :key="(product,index)" v-for="(product,index) in products">
            <transition name="fade" mode="out-in">
              <ProductCard :obj="product" v-if="index < paginator" />
            </transition>
          </template>
        </div>
        <div class="load-more mb-5">
          <button aria-label="بیشتر" v-if="paginator < products.length" class="btn btn-secondary my-4" @click="paginator += 10">بیشتر</button>
        </div>
      </div>
      <div class="container" v-if="!products">
        <div class="row justify-content-center">
          <template :key="(product,index)" v-for="(product,index) in 10">
            <transition name="fade" mode="out-in">
              <ProductCard :obj="null" v-if="index < paginator" />
            </transition>
          </template>
        </div>
      </div>
      <div class="container" v-if="products">
        <div class="load-more mb-5" v-if="products.length === 0">
          <h3 class="m-5">موردی یافت نشد</h3>
        </div>
      </div>
  </div>
</template>
<script>
import ProductCard from '@/components/ProductCard.vue'
import ImageSlider from '@/components/ImageSlider.vue'
import ImageSliderMobile from '@/components/ImageSliderMobile.vue'

export default {
  name: 'SearchPage',
  components: {
    ImageSlider,
    ImageSliderMobile,
    ProductCard
  },
  data () {
    return {
      response: {},
      products: null,
      paginator: 10,
      screen: screen.width
    }
  },
  methods: {
    pageLoad: function () {
      const query = `
{
  products(
    filters: {count: 300
    order: "-available"
    ${this.$route.query.pklist ? `pklist: "${this.$route.query.pklist}"` : ''}
    ${this.$route.query.q ? `q: "${this.$route.query.q}"` : ''}
    }
  ) {
    id
    available
    slug
    name
    image: PNG
    mlActivation
    specialTag
    concepts:concepts{
      id
      price
      name
      video
      videoCover
      image
      description
    }
    isOffInt
    priceAfterOff
    priceBeforeOff
    categorySlug
    subCategorySlug
    categoryId
  }
  sliders (key: "Home") {
    imageMobile
    image
    alt
    link
  }
}
      `
      this.$fetchGraphQL(query)
        .then((response) => {
          this.response = response.data
          this.products = response.data.products
        })
    }
  },
  mounted () {
    this.pageLoad()
  },
  watch: {
    '$route.query.q' (to, from) {
      this.pageLoad()
      this.products = null
      this.paginator = 10
    },
    '$route.query.pklist' (to, from) {
      this.pageLoad()
      this.products = null
      this.paginator = 10
    }
  }
}
</script>

<style scoped>
.br-20{
  border-radius: 24px;
}
.load-more{
  display: flex;
  justify-content: center;
}
</style>
